import { useDeleteTourPlanMutation } from '@/graphql/generated/hooks'

export const useDeleteTourPlan = () => {
  const [handleDeleteTourPlan, { loading: isDeleteLoading }] =
    useDeleteTourPlanMutation()

  const deleteTourPlan = async (id: string) => {
    const { data } = await handleDeleteTourPlan({
      variables: { input: { id } },
      refetchQueries: ['facilityTourPlans'],
    })
    return data
  }

  return {
    deleteTourPlan,
    isDeleteLoading,
  }
}
